import { canCallApp } from '../utils';

const setImageZoomCarousels = () => {
    document.querySelectorAll( '[data-image-zoom-carousel]' ).forEach( async carousel => {
        const imgs = carousel.querySelectorAll( 'img' );
        let imgUrls = await getImagesUrl( imgs );
        imgs.forEach( img => {
            img.addEventListener( 'click', () => {
                if ( canCallApp( 'showImages' ) ) {
                    const appData = {
                        'images': imgUrls,
                        'position': img.dataset.position
                    };
                    Trendier.showImages( JSON.stringify( appData ) );
                }
            } );
        } ); 
    } );
};

const getImagesUrl = async ( imgs ) => {
    let imgUrls = [];
    await imgs.forEach( img => imgUrls.push( img.dataset.src ?? img.src ) );
    return imgUrls;
}

export default setImageZoomCarousels;